import styled from 'styled-components';

const PopupPromotionRegisterStyle = styled.div`
	--sizePopup: 420px;

	--sizePad: var(--sp2x);
	--padPopupContent: var(--sp2-5x) var(--sp4x) var(--sp4x);
	--padPopupHeader: var(--sp3x) var(--sp4x) var(--sp5x);
	--distanceTitleHeaderSubtitle: var(--sp1x);
	--distanceCloseIconHeader: var(--sp3x);
	--sizeCloseIcon: var(--sp1-5x);
	--promoCodePad: 6px 6px 6px var(--sp2-5x);
	--radiusPromoCode: var(--sp7x);
	--distancePromoText: var(--sp3x);
	--distancePromoButton: var(--sp2x);
	--copyIconSize: var(--sp2-5x);
	--copyIconPad: var(--sp1-5x);

	.layer-background {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 999;
		background-color: rgba(0, 0, 0, 0.3);
		transition: opacity 0.3s ease-in-out;
		opacity: 0;
		pointer-events: none;

		&.open {
			opacity: 1;
			pointer-events: all;
		}
	}

	.width-100 {
		width: 100% !important;
	}

	.inner-wrapper {
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 1000;
		width: var(--sizePopup);
		max-width: calc(100% - var(--sizePad) * 2);
		pointer-events: none;
		transition:
			opacity 0.3s ease-in-out,
			transform 0.3s ease-in-out;
		transform: translate(-50%, calc(-50% + 24px));
		opacity: 0;

		&.open {
			transform: translate(-50%, -50%);
			opacity: 1;
			pointer-events: auto;
		}
	}

	.inner-content {
		border-radius: var(--sp2-5x);
		overflow: hidden;
		background-color: var(--white);
	}

	.popup-header {
		position: relative;
		background-color: var(--green);
		padding: var(--padPopupHeader);
	}

	.wrap-icon-close {
		display: flex;
		justify-content: flex-end;
		margin-bottom: var(--distanceCloseIconHeader);

		.icon-close-popup {
			font-size: var(--sizeCloseIcon) !important;
			color: var(--lightGreen);
			cursor: pointer;
		}
	}

	.popup-subtitle {
		display: block;
		margin-bottom: var(--distanceTitleHeaderSubtitle);
	}

	.popup-title {
		display: block;
	}

	.popup-body {
		display: flex;
		flex-direction: column;
		padding: var(--padPopupContent);
	}

	.promo-code-wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--sp2x);
		border: 2px solid #f4f4f4;
		border-radius: var(--radiusPromoCode);
		padding: var(--promoCodePad);
		margin-top: var(--distancePromoText);
	}

	.promo-code-text {
		color: var(--green);
		font-size: var(--h5);
		font-family: var(--futura);
		font-weight: 500;
	}

	.promo-code-copy {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		border: none;
		border-radius: 50%;
		background-color: #daf5f0;
		color: var(--green);
		cursor: pointer;
		padding: var(--copyIconPad);
		aspect-ratio: 1 / 1;

		transition:
			opacity 0.2s ease-in-out,
			width 0.2s ease-in-out,
			border-radius 0.2s ease-in-out;

		.icon-copy {
			width: var(--copyIconSize);
			height: var(--copyIconSize);
		}

		&.is-copied {
			width: auto;
			padding: 0 var(--sp1-5x);
			border-radius: var(--sp3x);
			cursor: default;
		}

		.promo-code-copied-text {
			white-space: nowrap;
		}

		@media (hover: hover) {
			&:not(.is-copied):hover {
				opacity: 0.8;
			}
		}
	}

	.wrapper-button {
		display: flex;
		justify-content: center;
		width: 100%;
		margin-top: var(--distancePromoButton);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--sizePad: var(--sp2x);

		--padPopupContent: var(--sp2-5x) var(--sp2-5x) var(--sp4x);
		--padPopupHeader: var(--sp3x) var(--sp2-5x) var(--sp3x);
		--distanceTitleHeaderSubtitle: var(--sp1x);
		--distanceCloseIconHeader: var(--sp2x);
		--sizeCloseIcon: var(--sp1-5x);
		--promoCodePad: 4px 4px 4px var(--sp2-5x);
		--radiusPromoCode: var(--sp7x);
		--distancePromoText: var(--sp2x);
		--distancePromoButton: var(--sp2x);
		--copyIconSize: var(--sp2x);
		--copyIconPad: var(--sp1-5x);
	}
`;

export default PopupPromotionRegisterStyle;
